// Pure role model — no DOM, no supabase. The DB check constraint
// (profiles_role_valid) is the source of truth for the value set; parseRole
// is the client's defense against anything else arriving off the wire.
export type Role = 'user' | 'lower_dev' | 'higher_dev' | 'admin';

const ROLES: readonly Role[] = ['user', 'lower_dev', 'higher_dev', 'admin'];

// Admin is deliberately absent: admins are created by hand-run SQL only.
export const assignableRoles: readonly Role[] = ['user', 'lower_dev', 'higher_dev'];

export function parseRole(value: unknown): Role {
  return ROLES.includes(value as Role) ? (value as Role) : 'user';
}

export function roleDisplayName(role: Role): string {
  switch (role) {
    case 'lower_dev':
      return 'Lower Dev';
    case 'higher_dev':
      return 'Higher Dev';
    case 'admin':
      return 'Admin';
    default:
      return 'Regular User';
  }
}

export function roleBadge(role: Role): { text: string; className: string } | null {
  switch (role) {
    case 'lower_dev':
      return { text: 'DEV', className: 'account-badge-lower-dev' };
    case 'higher_dev':
      return { text: 'DEV+', className: 'account-badge-higher-dev' };
    case 'admin':
      return { text: 'ADMIN', className: 'account-badge-admin' };
    default:
      return null;
  }
}

export function canOpenAdminPanel(role: Role): boolean {
  return role !== 'user';
}

export function canUseAdminTools(role: Role): boolean {
  return role === 'admin';
}

// UI-side mirror of admin_set_role's WHERE clause; the SQL stays the enforcer.
export function canEditTarget(targetRole: Role, targetId: string, selfId: string | null): boolean {
  return targetRole !== 'admin' && selfId !== null && targetId !== selfId;
}
